export const API = {
  me: {
    path: '/users/me',
    method: 'GET',
    get: null,
    auth: true,
    fallback: null,
  },
};
